module.exports = __webpack_public_path__ + "media/packs/compcalc/components/icons/job-displ-1649a5ac1183ac10d91ab289480373a0.png";